<button
  aria-label="Back"
  class="-ml-2 back-button w-12 active:bg-surface-200 hover:bg-surface-100 bg-white"
  (click)="onBackClick()"
>
  <i class="pi pi-angle-left text-2xl font-bold"></i>
</button>
